import * as React from 'react'
import i18next from 'i18next'
import { ButtonPrimary } from '../../utils/buttons'
import { TextPageHeader } from './pageHeader/pageHeaderLayout'
import { Pages } from './routes/routesState'
import { DataLayer } from '../../utils/datalayer'
import { ComponentDidMount } from '../../utils/lifecycleMethods'
import { UserType } from '../../subscription/subscriptionApi'
import { CurrentPage } from '../../utils/routes'

export const RootLayout = {
  Page: ({
    pageKind,
    isLoggedIn,
    child: children,
    userType,
  }: {
    pageKind: CurrentPage<Pages>
    isLoggedIn: boolean
    userType: UserType
    child: JSX.Element
  }) => {
    const { kind } = pageKind
    const userTypeClassName = isLoggedIn
      ? userType == 'trial'
        ? ' main--trial'
        : userType == 'pro' || userType == 'student' || userType == 'teacher'
        ? ' main--pro'
        : userType == 'expired'
        ? ' main--expired'
        : ''
      : ''
    const componentFilterClass =
      kind == 'componentOverview' ? ' main--componentFilter' : ''
    return (
      <main
        id="a11y-main"
        className={`main main--${
          kind === 'notFound' ? 'error' : kind
        }${componentFilterClass} main--${
          isLoggedIn ? 'logged-in' : 'logged-out'
        }${userTypeClassName}`}
      >
        <article className="main__inner">{children}</article>
      </main>
    )
  },
  PageLoader: () => (
    <div id="app-loader" aria-hidden="true">
      <div className="header">
        <div className="header__inner">
          <div className="header__toolbar">
            <div className="header__logo">
              <svg
                className="header__image"
                viewBox="0 0 556 106"
                width="556"
                height="106"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="header__image-text"
                  d="m23.8133736 49.312363c5.6899584 0 10.2961152-2.9017667 11.6508672-7.3556413v6.8157777h10.5670656v-19.0976741c0-3.5091133-2.5740288-7.4231242-7.3833984-7.4231242h-13.3443072v8.7727832h8.4672c.677376 0 1.0838016.4723806 1.0838016 1.214693 0 3.3066644-5.2835328 7.4906072-10.3638528 7.4906072-7.112448 0-12.870144-5.8710165-12.870144-14.5763167s5.757696-13.9014871 13.0733568-13.9014871c5.6222208 0 9.0768384 2.9017667 9.6864768 7.4906071h11.7863424c-.4064256-10.52733975-9.0091008-17.74801512-21.337344-17.74801512-12.870144 0-24.5887488 8.03047074-24.5887488 24.15889512 0 16.1284245 11.3121792 24.1588952 23.5726848 24.1588952zm38.2040064 0c4.402944 0 7.8575616-1.8895225 8.7381504-4.7238063v4.1839427h11.1089664v-21.8644749c0-7.693056-6.6382848-12.6867941-15.1732224-12.6867941-10.0929024 0-15.3086976 5.7360505-15.579648 12.6193111h9.7542144c.0677376-2.4293861 1.4224896-4.7238063 5.1480576-4.7238063 3.048192 0 4.741632 1.4171419 4.741632 3.4416303 0 1.6195908-.9483264 2.8342838-2.709504 2.8342838h-4.8771072c-7.1801856 0-12.0572928 4.0489769-12.0572928 10.7297886 0 5.6685676 4.5384192 10.1899251 10.9057536 10.1899251zm3.1159296-7.760539c-1.9643904 0-3.4546176-1.214693-3.4546176-2.9692496 0-2.0244885 1.4224896-3.4416304 3.38688-3.4416304h5.6899584v.2699318c0 3.1716986-2.032128 6.1409482-5.6222208 6.1409482zm35.1558144 7.760539c8.263987 0 13.615258-4.3863916 13.615258-11.0672034 0-15.2511461-18.0859396-7.8955048-18.0859396-13.9014871 0-1.7545567 1.4224896-2.631835 3.5223552-2.631835 2.3030784 0 4.2674684 1.6195908 4.6061564 3.914011h9.483264c-.27095-6.8832607-6.028646-11.4046181-14.5635836-11.4046181-6.8414976 0-12.2605056 4.4538745-12.2605056 10.5948227 0 14.103936 17.6795132 8.3678855 17.6795132 13.9014872 0 1.4846248-1.625702 2.4293861-3.996518 2.4293861-2.8449792 0-4.9448448-1.6195908-5.2835328-4.0489769h-9.4155264c.338688 7.4231242 6.1641216 12.2144135 14.6990592 12.2144135zm42.403738-.5398636v-9.1776808h-4.131994c-2.912717 0-4.470682-1.349659-4.470682-4.4538746v-11.2021692h8.602676v-9.1776809h-8.602676v-9.65006143h-11.176704v9.65006143h-6.299596v9.1776809h6.299596v11.7420328c0 8.4353684 5.554484 13.0916918 13.953946 13.0916918zm15.918336 0v-17.2081516c0-4.7912892 2.167603-7.625573 5.893171-7.625573h5.960909v-9.1776809h-3.590093c-3.793306 0-6.299597 1.0797272-8.263987 5.128704v-5.128704h-11.176704v34.0114055zm32.378572.5398636c10.634804 0 18.289152-7.4906072 18.289152-17.5455663 0-10.0549592-7.654348-17.5455663-18.289152-17.5455663-10.634803 0-18.289152 7.4906071-18.289152 17.5455663 0 10.0549591 7.654349 17.5455663 18.289152 17.5455663zm0-9.4476126c-4.267468 0-7.112448-3.2391815-7.112448-8.0979537s2.84498-8.0979537 7.112448-8.0979537c4.267469 0 7.112448 3.2391815 7.112448 8.0979537s-2.844979 8.0979537-7.112448 8.0979537zm31.701197 8.907749v-18.5578105c0-4.9937381 3.251405-8.6378173 7.925299-8.6378173 4.267469 0 7.112448 3.2391815 7.112448 7.8955049v19.3001229h8.331725v-21.0546796c0-7.9629878-5.012582-13.4965894-12.734669-13.4965894-4.877107 0-8.73815 2.0919713-10.634803 5.8035334v-5.2636699h-8.331725v34.0114055zm46.874419.5398636c10.363853 0 17.814989-7.4231242 17.814989-17.5455663s-7.451136-17.5455663-17.814989-17.5455663c-10.43159 0-17.882726 7.4231242-17.882726 17.5455663s7.451136 17.5455663 17.882726 17.5455663zm0-7.1531924c-5.689958 0-9.483264-4.2514257-9.483264-10.3923739s3.793306-10.3923739 9.483264-10.3923739c5.622221 0 9.415527 4.2514257 9.415527 10.3923739s-3.793306 10.3923739-9.415527 10.3923739zm31.768935 6.6133288v-19.5025718c0-4.7912892 2.777241-7.9629878 7.180185-7.9629878 3.996519 0 6.50281 3.1716986 6.50281 7.9629878v19.5025718h8.263987v-19.5025718c0-4.7912892 2.777242-7.9629878 7.247923-7.9629878 3.996519 0 6.50281 3.1716986 6.50281 7.9629878v19.5025718h8.263987v-21.9994408c0-7.2206754-4.741632-12.5518282-12.12503-12.5518282-5.419008 0-9.754215 2.9692496-11.312179 6.4783629-1.490228-4.1839427-5.215796-6.4783629-10.634804-6.4783629-4.809369 0-8.196249 2.4293861-9.889689 5.8710164v-5.3311529h-8.331725v34.0114055zm60.015513-39.3425583v-9.24516379h-8.941363v9.24516379zm-.27095 39.3425583v-34.0114055h-8.331725v34.0114055zm13.27657 0 7.993036-11.3371351 7.993037 11.3371351h8.805888l-12.328243-17.7480151 11.447654-16.2633904h-9.144576l-6.77376 9.7850274-6.841497-9.7850274h-9.076839l11.379917 16.2633904-12.328243 17.7480151zm41.523148.5398636c7.993037 0 13.208832-4.1839427 13.208832-10.5948227 0-15.386112-18.966528-7.2881584-18.966528-14.6437996 0-2.2944202 1.964391-3.6440792 4.944845-3.6440792 2.641767 0 5.554483 1.6195908 6.028647 4.7912893h7.586611c-.338688-6.6133289-5.825434-10.9997204-13.818471-10.9997204-7.04471 0-12.260505 4.1839427-12.260505 10.1224421 0 14.3738678 18.695577 7.1531924 18.695577 14.7112825 0 2.0244884-2.167603 3.6440792-5.419008 3.6440792-3.725568 0-6.231859-2.0244885-6.570547-5.2636699h-7.586611c.406426 7.2881583 5.893171 11.8769987 14.157158 11.8769987z"
                  fill="#151619"
                  fillRule="nonzero"
                  transform="translate(125.977039 25.757774)"
                />
                <g className="header__image-icon">
                  <path
                    d="m45.7080455.0001912-45.70842935 26.2892756 22.85459855 22.1266167 22.8538308 4.1636149.1439424-.0822168v-52.41507367z"
                    fill="#FFDBCD"
                  />
                  <path
                    d="m0 78.8703123 26.7104526-6.3562581 18.9979767-19.9339734-45.7084293-26.2902316z"
                    fill="#FFB79C"
                  />
                  <path
                    d="m0 78.8703123.28884442.1663455 45.41958488 26.1238862.1439424-.082217 7.5685335-32.5642728-7.5685335-19.8508007-.1439424-.0831727z"
                    fill="#FF946A"
                  />
                  <path
                    d="m45.8522758 105.078327 45.5625676-26.2070587-22.7812838-20.8553355-22.7812838-5.3526793z"
                    fill="#FF7039"
                  />
                  <path
                    d="m45.8522758 52.4979596v.1653895l45.5625676 26.2061028v-52.5785511z"
                    fill="#FF4C07"
                  />
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <RootLayout.Loader hasWrapper={false} showText={true} />
    </div>
  ),
  Loader: ({
    hasWrapper,
    showText,
    text,
  }: {
    hasWrapper: boolean
    showText: boolean
    text?: string
  }) =>
    hasWrapper ? (
      <div className="block--loader">
        <div className="block__empty-state text--styled">
          <Loader showText={showText} text={text} />
        </div>
      </div>
    ) : (
      <Loader showText={showText} text={text} />
    ),
  LoadingFailed: ({ text }: { text: string }) => (
    <div className="block--loader">
      <div className="block__empty-state text--styled">
        <p>{text}</p>
      </div>
    </div>
  ),
  EmptyState: ({ text }: { text: string }) => (
    <div className="block__empty-state text--styled">
      <p>{text}</p>
    </div>
  ),
  Error: () => <Error />,
}

const Loader = ({ showText, text }: { showText: boolean; text?: string }) => (
  <div className="loader">
    <svg
      className="loader__svg"
      viewBox="0 0 290 332"
      width="290"
      height="332"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        className="loader__part loader__part--tr"
        d="m0 6.92817356v146.64660944c0 2.209139 1.790861 4 4 4 .70214894 0 1.39192761-.184826 2.00000584-.535901l126.99998616-73.3237622c1.913168-1.1045727 2.568665-3.5509354 1.464092-5.4641041-.351075-.6080786-.85603-1.1130307-1.464111-1.4641032l-126.99998585-73.32284798c-1.91317459-1.1045624-4.35953378-.4490527-5.46409618 1.46412189-.35106856.60807378-.53589097 1.29784552-.53589097 1.99998715z"
        transform="translate(148.0005 .0001)"
      />
      <path
        className="loader__part loader__part--tl"
        d="m133.000013 3.46406452-126.99998614 73.32284798c-1.91317459 1.1045625-2.56868428 3.5509216-1.46412188 5.4640962.35107244.6080806.85602457 1.1130354 1.46410319 1.4641111l126.99998583 73.3237622c1.913169 1.104572 4.359532.449076 5.464104-1.464093.351076-.608078.535902-1.297857.535902-2.000006v-146.64660944c0-2.209139-1.790861-4-4-4-.702142 0-1.391913.18482241-1.999987.53589096z"
        transform="translate(3.0002 .0001)"
      />
      <path
        className="loader__part loader__part--cl"
        d="m6.00000584 157.039882 127.00002316-73.3237838c1.913169-1.1045727 2.568665-3.5509354 1.464093-5.464104-.351072-.6080723-.856021-1.1130204-1.464093-1.4640924l-127.00002316-73.32378332c-1.91316863-1.10457273-4.35953136-.44907623-5.46410408 1.4640924-.3510755.60807823-.53590176 1.2978569-.53590176 2.00000584v146.64756628c0 2.209139 1.790861 4 4 4 .70214894 0 1.39192761-.184826 2.00000584-.535901z"
        transform="translate(0 85.4472)"
      />
      <path
        className="loader__part loader__part--cr"
        d="m6.00020817 84.1632198 126.99998583 73.3237622c1.913169 1.104572 4.359532.449076 5.464104-1.464093.351076-.608078.535902-1.297857.535902-2.000006v-146.64660944c0-2.209139-1.790861-4-4-4-.702142 0-1.391913.18482241-1.999987.53589096l-126.99998614 73.32284798c-1.91317459 1.1045625-2.56868428 3.5509216-1.46412188 5.4640962.35107244.6080806.85602457 1.1130354 1.46410319 1.4641111z"
        transform="translate(151 85)"
      />
      <path
        className="loader__part loader__part--bl"
        d="m6.00060817 84.0997416 126.99998583 73.3237614c1.913169 1.104573 4.359532.449077 5.464104-1.464092.351076-.608078.535902-1.297857.535902-2.000006v-146.64660964c0-2.209139-1.790861-4-4-4-.702142 0-1.391913.18482241-1.999987.53589097l-126.99998614 73.32284807c-1.91317459 1.1045624-2.56868428 3.5509215-1.46412188 5.4640961.35107244.6080806.85602457 1.1130354 1.46410319 1.4641111z"
        transform="translate(3 170.511278)"
      />
      <path
        className="loader__part loader__part--br"
        d="m6.00000584 157.038882 126.99998616-73.3237622c1.913168-1.1045727 2.568665-3.5509354 1.464092-5.4641041-.351075-.6080786-.85603-1.1130307-1.464111-1.4641032l-126.99998585-73.32284798c-1.91317459-1.1045624-4.35953378-.4490527-5.46409618 1.46412189-.35106856.60807378-.53589097 1.29784552-.53589097 1.99998715v146.64660944c0 2.209139 1.790861 4 4 4 .70214894 0 1.39192761-.184826 2.00000584-.535901z"
        transform="translate(148.0005 170.896)"
      />
    </svg>
    {showText && (
      <p id="a11y-loader-text" className="loader__text text--s">
        {text || i18next.t('common:loading')}
      </p>
    )}
  </div>
)

const Error = () => (
  <>
    <ComponentDidMount onMount={DataLayer.pageNotFound} />
    <div className="text-screen">
      <TextPageHeader
        title={i18next.t('pageNotFound:pageNotFoundTitle')}
        intro={i18next.t('pageNotFound:pageNotFoundIntro')}
      />
      <section className="block block--text">
        <div className="block__inner container--m gutter--m">
          <div className="block__content">
            <div className="block__text text--styled">
              <p>{i18next.t('pageNotFound:pageNotFoundTextA')}</p>
              <p>
                {i18next.t('pageNotFound:pageNotFoundTextB')}{' '}
                {i18next.t('pageNotFound:pageNotFoundTextC')}.
              </p>
            </div>
          </div>

          <footer className="block__footer block__clickables">
            <div className="block__clickable">
              <ButtonPrimary
                kind="button"
                size="s"
                onClick={window.history.back}
                label={i18next.t(
                  'pageNotFound:pageNotFoundPrimaryButton'
                )}
              />
            </div>
          </footer>
        </div>
      </section>
    </div>
  </>
)
